import PropTypes from 'prop-types';
import { generatePath } from 'react-router-dom';

import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './MenuItem.style';

const MenuItem = ({ section, onClick, index }) => (section.type === 'divider' ? (
  <Styled.Root className="is-divider" />
) : (
  <Styled.Root>
    <Styled.Link
      clickstreamProps={{
        elementText: section.title,
        elementName: 'user_menu_option',
        destination: section.path,
        // TODO: Check to see if these are still needed
        dynamicProperties: {
          navIndex: index + 1,
          navLevel: 1
        }
      }}
      onClick={onClick}
      to={generatePath(section.path)}
    >
      <SharedAsset
        alt={section.icon.alt}
        src={`/s2/icon/${section.icon.src}`}
        width={16}
      />
      <Text truncate>{section.title}</Text>
    </Styled.Link>
  </Styled.Root>
));

MenuItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  section: PropTypes.shape({
    type: PropTypes.string,
    title: PropTypes.string,
    path: PropTypes.string,
    icon: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string
    })
  }).isRequired
};

export default MenuItem;
